export default __webpack_public_path__ + "static/platform-favicon-8463e9d5371ff098dec62fad32d725af.ico";